module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-window",
    attrs: {
      "id": "news_window"
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "prize-box container"
  }, [_c('img', {
    staticClass: "icon-close",
    attrs: {
      "src": require("../../image/newVersion/icon_close.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.newsClickHandler('关闭', true)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prize-content"
  }, [_c('p', {
    staticClass: "prize-title"
  }, [_vm._v(_vm._s('恭喜你获得了一张优惠劵'))]), _vm._v(" "), (_vm.getCouponData) ? _c('div', {
    staticClass: "prize-info"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('span', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-icon"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "price-count"
  }, [_vm._v(_vm._s(parseInt(_vm.getCouponData.value || 0)))])]), _vm._v(" "), _c('span', {
    staticClass: "limit"
  }, [_c('span', {
    staticClass: "desc"
  }, [_vm._v("满" + _vm._s(parseInt(_vm.getCouponData.mininum || 0)) + "可用")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-right"
  }, [_c('span', {
    staticClass: "info-name"
  }, [_vm._v("全场通用")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatTime(_vm.getCouponData.end_time)) + "过期")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "prize-btn",
    on: {
      "click": function($event) {
        return _vm.newsClickHandler('去使用')
      }
    }
  }, [_vm._v("去使用")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01c7e730", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c7e730","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/newUserPopV2.vue
// module id = 410
// module chunks = 32